var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m6 32c0-14.3594 11.6406-26 26-26 1.1046 0 2-.89543 2-2s-.8954-2-2-2c-16.5685 0-30 13.4315-30 30s13.4315 30 30 30c1.1046 0 2-.8954 2-2s-.8954-2-2-2c-14.3594 0-26-11.6406-26-26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 20c-6.6274 0-12 5.3726-12 12s5.3726 12 12 12 12-5.3726 12-12c0-1.1046.8954-2 2-2s2 .8954 2 2c0 8.8366-7.1634 16-16 16s-16-7.1634-16-16 7.1634-16 16-16c1.1046 0 2 .8954 2 2s-.8954 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.4142 44.5858 5.5858 5.5858 5.5858-5.5858c.781-.7811 2.0474-.7811 2.8284 0 .7811.781.7811 2.0474 0 2.8284l-5.5858 5.5858 5.5858 5.5858c.7811.781.7811 2.0474 0 2.8284-.781.7811-2.0474.7811-2.8284 0l-5.5858-5.5858-5.5858 5.5858c-.781.7811-2.0474.7811-2.8284 0-.7811-.781-.7811-2.0474 0-2.8284l5.5858-5.5858-5.5858-5.5858c-.7811-.781-.7811-2.0474 0-2.8284.781-.7811 2.0474-.7811 2.8284 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.617 10.0107c-.3964.3964-.6083.941-.5839 1.501l.3153 7.2528-10.7627 10.7627c-.781.781-.781 2.0473 0 2.8284.7811.781 2.0474.781 2.8285 0l10.7626-10.7627 7.2528.3154c.5601.0243 1.1047-.1875 1.5011-.5839l7.4246-7.4247c.5608-.5608.7373-1.4.4497-2.1392-.2875-.7392-.9847-1.2386-1.777-1.2731l-6.3002-.2739-.2739-6.30013c-.0344-.79238-.5339-1.48954-1.273-1.77707-.7392-.28753-1.5785-.1111-2.1393.44973z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetX);
export default __webpack_public_path__ + "static/media/target_x.d2ee93fbff4763d2c5488242923df510.svg";
export { ForwardRef as ReactComponent };